import axios, { buildApi } from '@/libs/api.request';
let name = '/report/tracker'

export const apis = buildApi({
  get: [name + '/timeout&list',],
  post: [name + '/save', name + '/delete/:id&del']
})